import { useState, useEffect } from 'react';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [selectedImageCollection, setSelectedImageCollection] = useState<string>('');
  const [imageZoom, setImageZoom] = useState(1);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [galleryFilter, setGalleryFilter] = useState<string>('bamboo-coral');
  const [aboutTextVisible, setAboutTextVisible] = useState(false);
  const [aboutExpanded, setAboutExpanded] = useState(false);
  const [bespokeExpanded, setBespokeExpanded] = useState(false);
  const [isPortraitMode, setIsPortraitMode] = useState(false);
  const [aboutImagesExpanded, setAboutImagesExpanded] = useState(false);
  const [currentAboutImageIndex, setCurrentAboutImageIndex] = useState(0);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [contactFormStatus, setContactFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [orderFormStatus, setOrderFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [selectedColor, setSelectedColor] = useState<string>('');
  const [isColorDropdownOpen, setIsColorDropdownOpen] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState<string>('');
  const [isCollectionDropdownOpen, setIsCollectionDropdownOpen] = useState(false);
  const [selectedSize, setSelectedSize] = useState<string>('');
  const [isSizeDropdownOpen, setIsSizeDropdownOpen] = useState(false);
  const [selectedGlaze, setSelectedGlaze] = useState<string>('');
  const [isGlazeDropdownOpen, setIsGlazeDropdownOpen] = useState(false);
  const [orderDetailsLength, setOrderDetailsLength] = useState(0);
  const [contactMessageLength, setContactMessageLength] = useState(0);
  const [heroVisible, setHeroVisible] = useState(false);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [bespokeVisible, setBespokeVisible] = useState(false);
  const [contactVisible, setContactVisible] = useState(false);

  // Collection images data
  const collectionImages = {
    'bamboo-coral': [
      'https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/3cea0bd8bc9420efe67aec7631b35ac0.jpeg',
      'https://readdy.ai/api/search-image?query=Elegant%20ceramic%20vase%20inspired%20by%20bamboo%20and%20coral%20textures%20with%20cylindrical%20form%20and%20delicate%20surface%20patterns%20in%20sage%20green%20and%20coral%20tones%20minimalist%20studio%20photography%20with%20clean%20white%20background%20professional%20fine%20art%20ceramic%20photography%20showcasing%20organic%20textures%20and%20natural%20inspiration&width=400&height=500&seq=bamboo-coral-2-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Beautiful%20ceramic%20bowl%20with%20bamboo-inspired%20ridged%20texture%20and%20coral-like%20organic%20patterns%20handcrafted%20pottery%20with%20natural%20earth%20tones%20and%20tropical%20influences%20elegant%20minimalist%20photography%20with%20soft%20lighting%20clean%20background%20showcasing%20artisan%20craftsmanship&width=400&height=500&seq=bamboo-coral-3-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Cylindrical%20ceramic%20vase%20with%20bamboo%20texture%20and%20coral%20patterns%20side%20angle%20view%20showing%20detailed%20surface%20work%20handcrafted%20pottery%20with%20tropical%20inspiration%20professional%20studio%20photography&width=400&height=500&seq=bamboo-coral-4-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Handcrafted%20ceramic%20piece%20with%20bamboo%20and%20coral%20inspired%20textures%20elegant%20form%20with%20natural%20patterns%20minimalist%20photography%20clean%20background&width=400&height=500&seq=bamboo-coral-5-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Beautiful%20ceramic%20vessel%20with%20tropical%20bamboo%20and%20coral%20textures%20artisan%20pottery%20with%20organic%20patterns%20professional%20studio%20photography&width=400&height=500&seq=bamboo-coral-6-v1&orientation=portrait',
    ],
    'cactus': [
      'https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/01c740efd46ee4a011ffe990b731ed0d.jpeg',
      'https://readdy.ai/api/search-image?query=Sculptural%20ceramic%20vessel%20inspired%20by%20cactus%20forms%20with%20bold%20geometric%20shapes%20and%20desert-inspired%20textures%20rough%20yet%20graceful%20pottery%20with%20earthy%20tones%20and%20Mexican%20influence%20minimalist%20studio%20photography%20with%20clean%20background%20professional%20ceramic%20art%20photography&width=400&height=500&seq=cactus-2-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Handcrafted%20ceramic%20planter%20with%20cactus-inspired%20ridged%20surface%20and%20natural%20desert%20colors%20bold%20angular%20forms%20with%20organic%20textures%20artisan%20pottery%20with%20Mexican%20desert%20influence%20elegant%20photography%20with%20soft%20lighting%20clean%20minimalist%20background&width=400&height=500&seq=cactus-3-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Desert-inspired%20ceramic%20vessel%20with%20cactus%20texture%20top%20view%20showing%20geometric%20patterns%20handcrafted%20pottery%20with%20Mexican%20influence%20professional%20ceramic%20photography&width=400&height=500&seq=cactus-4-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Bold%20ceramic%20piece%20with%20cactus%20inspired%20geometric%20forms%20desert%20textures%20and%20earthy%20tones%20minimalist%20photography%20clean%20background&width=400&height=500&seq=cactus-5-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Sculptural%20ceramic%20vessel%20with%20Mexican%20desert%20cactus%20influence%20rough%20elegant%20forms%20professional%20studio%20photography&width=400&height=500&seq=cactus-6-v1&orientation=portrait',
    ],
    'distorted-forms': [
      'https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/7144e3cb6dea54b14e9a220dfc3bfc6b.jpeg',
      'https://readdy.ai/api/search-image?query=Playful%20ceramic%20vessel%20with%20irregular%20spontaneous%20form%20and%20organic%20distorted%20shape%20celebrating%20imperfection%20and%20artistic%20freedom%20handcrafted%20pottery%20with%20joyful%20asymmetrical%20design%20contemporary%20ceramic%20art%20with%20vibrant%20colors%20minimalist%20photography%20clean%20background&width=400&height=500&seq=distorted-2-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Unique%20ceramic%20sculpture%20with%20spontaneous%20irregular%20form%20and%20charming%20imperfections%20artisan%20pottery%20celebrating%20human%20touch%20and%20artistic%20freedom%20contemporary%20design%20with%20organic%20flowing%20shapes%20professional%20studio%20photography%20with%20soft%20lighting&width=400&height=500&seq=distorted-3-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Asymmetrical%20ceramic%20piece%20with%20playful%20distorted%20form%20side%20angle%20view%20showing%20organic%20curves%20handcrafted%20pottery%20celebrating%20imperfection%20professional%20ceramic%20photography&width=400&height=500&seq=distorted-4-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Contemporary%20ceramic%20vessel%20with%20irregular%20spontaneous%20form%20celebrating%20artistic%20freedom%20handcrafted%20pottery%20with%20organic%20shapes%20minimalist%20photography&width=400&height=500&seq=distorted-5-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Playful%20asymmetrical%20ceramic%20sculpture%20with%20joyful%20imperfections%20artisan%20pottery%20with%20vibrant%20contemporary%20design%20professional%20studio%20photography&width=400&height=500&seq=distorted-6-v1&orientation=portrait',
    ],
    'fish-scale': [
      'https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/cd86995edab4226af9dd68e981057471.jpeg',
      'https://readdy.ai/api/search-image?query=Delicate%20ceramic%20bowl%20with%20layered%20fish%20scale%20texture%20and%20shimmering%20surface%20patterns%20inspired%20by%20water%20and%20femininity%20handcrafted%20pottery%20with%20luminous%20glazes%20and%20fluid%20organic%20shapes%20celebrating%20new%20beginnings%20professional%20ceramic%20photography%20clean%20background&width=400&height=500&seq=fish-scale-2-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Beautiful%20ceramic%20vase%20with%20intricate%20fish%20scale%20pattern%20and%20iridescent%20surface%20texture%20inspired%20by%20Pisces%20and%20water%20elements%20artisan%20pottery%20with%20flowing%20feminine%20forms%20and%20luminous%20glazes%20elegant%20studio%20photography%20with%20soft%20lighting&width=400&height=500&seq=fish-scale-3-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Ceramic%20vessel%20with%20fish%20scale%20texture%20close-up%20detail%20showing%20layered%20pattern%20and%20luminous%20glaze%20handcrafted%20pottery%20inspired%20by%20water%20professional%20photography&width=400&height=500&seq=fish-scale-4-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Shimmering%20ceramic%20piece%20with%20delicate%20fish%20scale%20texture%20water-inspired%20patterns%20and%20luminous%20glazes%20handcrafted%20pottery%20minimalist%20photography&width=400&height=500&seq=fish-scale-5-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Elegant%20ceramic%20bowl%20with%20layered%20fish%20scale%20pattern%20feminine%20fluid%20forms%20and%20iridescent%20surface%20artisan%20pottery%20professional%20studio%20photography&width=400&height=500&seq=fish-scale-6-v1&orientation=portrait',
    ],
    'leaves': [
      'https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/07be09089f9257215cab403bc5d05125.jpeg',
      'https://readdy.ai/api/search-image?query=Elegant%20ceramic%20vessel%20with%20laurel%20leaf%20crown%20pattern%20and%20classical%20heritage%20inspiration%20handcrafted%20pottery%20celebrating%20achievement%20and%20knowledge%20with%20sophisticated%20leaf%20textures%20Italian-inspired%20design%20with%20quiet%20dignity%20professional%20ceramic%20photography&width=400&height=500&seq=leaves-2-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Beautiful%20ceramic%20bowl%20with%20delicate%20leaf%20impressions%20and%20natural%20botanical%20textures%20inspired%20by%20laurel%20crowns%20and%20Italian%20heritage%20artisan%20pottery%20with%20elegant%20organic%20patterns%20celebrating%20continuity%20and%20triumph%20minimalist%20studio%20photography&width=400&height=500&seq=leaves-3-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Ceramic%20piece%20with%20laurel%20leaf%20pattern%20side%20view%20showing%20botanical%20detail%20handcrafted%20pottery%20with%20Italian%20heritage%20inspiration%20professional%20ceramic%20photography&width=400&height=500&seq=leaves-4-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Sophisticated%20ceramic%20vessel%20with%20laurel%20leaf%20crown%20texture%20classical%20heritage%20inspiration%20handcrafted%20pottery%20minimalist%20photography&width=400&height=500&seq=leaves-5-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Elegant%20ceramic%20bowl%20with%20delicate%20botanical%20leaf%20impressions%20Italian-inspired%20design%20artisan%20pottery%20professional%20studio%20photography&width=400&height=500&seq=leaves-6-v1&orientation=portrait',
    ],
    'pine-nuts': [
      'https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/b9fa075d7b9312141c707e8feec95f30.jpeg',
      'https://readdy.ai/api/search-image?query=Sculptural%20ceramic%20vessel%20inspired%20by%20pine%20cone%20textures%20and%20Lebanese%20mountain%20landscapes%20with%20organic%20earthy%20forms%20and%20natural%20patterns%20handcrafted%20pottery%20rooted%20in%20memory%20and%20place%20artisan%20ceramics%20with%20mountain%20studio%20inspiration%20professional%20photography&width=400&height=500&seq=pine-nuts-2-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Beautiful%20ceramic%20bowl%20with%20pine%20cone%20inspired%20surface%20texture%20and%20natural%20mountain%20colors%20handcrafted%20pottery%20celebrating%20Lebanese%20landscape%20and%20organic%20forms%20artisan%20ceramics%20with%20earthy%20sculptural%20qualities%20elegant%20studio%20photography&width=400&height=500&seq=pine-nuts-3-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Pine%20cone%20textured%20ceramic%20vessel%20close-up%20showing%20organic%20pattern%20handcrafted%20pottery%20inspired%20by%20Lebanese%20mountains%20professional%20ceramic%20photography&width=400&height=500&seq=pine-nuts-4-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Earthy%20ceramic%20piece%20with%20pine%20cone%20texture%20Lebanese%20mountain%20inspiration%20sculptural%20organic%20forms%20handcrafted%20pottery%20minimalist%20photography&width=400&height=500&seq=pine-nuts-5-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Sculptural%20ceramic%20vessel%20with%20natural%20pine%20cone%20patterns%20mountain%20landscape%20inspiration%20artisan%20pottery%20professional%20studio%20photography&width=400&height=500&seq=pine-nuts-6-v1&orientation=portrait',
    ],
    'private-collections': [
      'https://readdy.ai/api/search-image?query=Elegant%20ceramic%20vessel%20created%20for%20special%20client%20with%20personal%20meaningful%20design%20handcrafted%20pottery%20with%20intimate%20emotional%20quality%20unique%20bespoke%20piece%20reflecting%20personal%20bond%20and%20memory%20artisan%20ceramics%20with%20distinctive%20character%20professional%20studio%20photography%20with%20clean%20white%20background&width=400&height=500&seq=private-1-v1&orientation=portrait',
      'https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/425cbf967012cf63be779d098d092ce4.jpeg',
      'https://readdy.ai/api/search-image?query=Unique%20ceramic%20piece%20created%20for%20close%20friend%20with%20personal%20inspiration%20and%20shared%20memories%20handcrafted%20pottery%20reflecting%20intimate%20bond%20and%20emotional%20journey%20bespoke%20artisan%20ceramics%20with%20meaningful%20presence%20professional%20fine%20art%20photography&width=400&height=500&seq=private-3-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Bespoke%20ceramic%20vessel%20with%20personal%20design%20detail%20view%20handcrafted%20pottery%20for%20special%20occasion%20professional%20ceramic%20photography&width=400&height=500&seq=private-4-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Intimate%20ceramic%20piece%20with%20personal%20meaningful%20design%20created%20for%20special%20client%20handcrafted%20pottery%20minimalist%20photography&width=400&height=500&seq=private-5-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Unique%20bespoke%20ceramic%20vessel%20reflecting%20personal%20bond%20and%20shared%20memories%20artisan%20pottery%20professional%20studio%20photography&width=400&height=500&seq=private-6-v1&orientation=portrait',
    ],
    'the-palm': [
      'https://readdy.ai/api/search-image?query=Elegant%20ceramic%20vessel%20inspired%20by%20palm%20fronds%20with%20layered%20petal-like%20forms%20and%20timeless%20grace%20handcrafted%20pottery%20reflecting%20Doha%20warmth%20and%20golden%20desert%20sun%20with%20serene%20coastal%20influences%20artisan%20ceramics%20celebrating%20hospitality%20and%20tradition%20professional%20studio%20photography%20with%20clean%20white%20background&width=400&height=500&seq=palm-1-v1&orientation=portrait',
      'https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/de48ea164b256671d45652efa61d4828.jpeg',
      'https://readdy.ai/api/search-image?query=Sculptural%20ceramic%20piece%20with%20palm%20petal%20layers%20and%20timeless%20elegant%20form%20inspired%20by%20Doha%20serenity%20and%20tradition%20handcrafted%20pottery%20reflecting%20calm%20breath%20of%20sea%20and%20hospitality%20artisan%20ceramics%20with%20family%20memories%20professional%20fine%20art%20photography&width=400&height=500&seq=palm-3-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Palm-inspired%20ceramic%20vessel%20side%20angle%20showing%20layered%20petal%20forms%20handcrafted%20pottery%20with%20Doha%20influence%20professional%20ceramic%20photography&width=400&height=500&seq=palm-4-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Elegant%20ceramic%20piece%20with%20palm%20frond%20inspiration%20layered%20petal%20forms%20Doha%20warmth%20handcrafted%20pottery%20minimalist%20photography&width=400&height=500&seq=palm-5-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Sculptural%20ceramic%20vessel%20with%20timeless%20palm%20petal%20layers%20coastal%20serenity%20artisan%20pottery%20professional%20studio%20photography&width=400&height=500&seq=palm-6-v1&orientation=portrait',
    ],
    'totem': [
      'https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/46c5fe9c1b6d2bbfdbba49d958b69ce3.jpeg',
      'https://readdy.ai/api/search-image?query=Sculptural%20ceramic%20totem%20with%20sacred%20object%20qualities%20and%20contemporary%20interior%20design%20appeal%20handcrafted%20pottery%20serving%20as%20emotional%20anchor%20with%20distinctive%20presence%20and%20quiet%20strength%20artisan%20ceramics%20with%20personality%20and%20meaning%20professional%20studio%20photography&width=400&height=500&seq=totem-2-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Elegant%20ceramic%20sculpture%20designed%20as%20sculptural%20anchor%20for%20contemporary%20spaces%20with%20distinctive%20form%20and%20emotional%20weight%20handcrafted%20totem%20pottery%20bringing%20warmth%20and%20soul%20to%20interiors%20artisan%20ceramics%20with%20conversation-starting%20presence&width=400&height=500&seq=totem-3-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Totem%20ceramic%20sculpture%20side%20view%20showing%20sculptural%20form%20handcrafted%20pottery%20with%20contemporary%20design%20professional%20ceramic%20photography&width=400&height=500&seq=totem-4-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Contemporary%20ceramic%20totem%20with%20sacred%20object%20qualities%20distinctive%20presence%20handcrafted%20pottery%20minimalist%20photography&width=400&height=500&seq=totem-5-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Sculptural%20ceramic%20anchor%20piece%20with%20emotional%20weight%20contemporary%20interior%20design%20artisan%20pottery%20professional%20studio%20photography&width=400&height=500&seq=totem-6-v1&orientation=portrait',
    ],
    'tribal-heritage': [
      'https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/f0e709957f64d1aab0b8690972438189.jpeg',
      'https://readdy.ai/api/search-image?query=Matte%20ceramic%20vessel%20inspired%20by%20African%20landscapes%20and%20enduring%20traditions%20with%20desert%20dune%20curves%20and%20ancient%20woven%20patterns%20handcrafted%20pottery%20reflecting%20soil%20and%20sunlight%20textures%20artisan%20ceramics%20celebrating%20resilience%20and%20timeless%20beauty&width=400&height=500&seq=tribal-2-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Beautiful%20ceramic%20bowl%20with%20tribal-inspired%20carvings%20and%20African%20heritage%20patterns%20matte%20finish%20reflecting%20vast%20landscapes%20and%20traditional%20craftsmanship%20handcrafted%20pottery%20with%20tactile%20story%20of%20cultural%20resilience%20professional%20ceramic%20photography&width=400&height=500&seq=tribal-3-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Tribal-inspired%20ceramic%20vessel%20close-up%20showing%20carved%20patterns%20handcrafted%20pottery%20with%20African%20heritage%20influence%20professional%20ceramic%20photography&width=400&height=500&seq=tribal-4-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Matte%20ceramic%20piece%20with%20African%20landscape%20inspiration%20desert%20dune%20curves%20handcrafted%20pottery%20minimalist%20photography&width=400&height=500&seq=tribal-5-v1&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Tribal%20heritage%20ceramic%20vessel%20with%20ancient%20woven%20patterns%20cultural%20resilience%20artisan%20pottery%20professional%20studio%20photography&width=400&height=500&seq=tribal-6-v1&orientation=portrait',
    ],
  };

  // Collection descriptions
  const collectionDescriptions: Record<string, string> = {
    'bamboo-coral': 'Inspired by an unforgettable journey to Bali, this collection reflects Nicole\'s love for the exotic and the raw beauty of nature. From dense bamboo groves to vibrant coral reefs, the island\'s landscapes left a lasting impression. Through cylindrical forms and delicate textures, each piece captures the rhythm, movement, fluidity, softness, and vibrant spirit of that tropical escape.',
    'cactus': 'Rough yet graceful, bold yet balanced, these forms were inspired by a journey through Mexico, where the striking silhouettes of cacti stood against sun-bleached skies. A celebration of contrasts, resilience, and natural geometry.',
    'distorted-forms': 'This collection explores spontaneity, playfulness, and the quiet charm found in everyday gestures. This collection reflects Nicole\'s instinctive relationship with clay, embracing irregularity, movement, and the poetry of form. It celebrates the beauty of being unapologetically human, where each piece carries a subtle trace of spontaneity and artistic freedom, full of charm, almost like a self-portrait in clay. Inspired by the beauty of irregularity, the collection captures joyful imperfections and celebrates spontaneous authenticity.',
    'fish-scale': 'Delicate, layered, and shimmering, this collection was born in March, the month Nicole welcomed her daughter into the world under the sign of Pisces. It is an ode to water, femininity, and the rhythm of new beginnings. Each piece carries the spirit of joy, happiness, and gladness, reflected in its fluid shapes and luminous surfaces.',
    'leaves': 'Evoking the timeless symbolism of the laurel leaf crown, this collection channels quiet elegance, strength, and heritage. In Italy, the laurel crown is traditionally worn during graduation ceremonies, a symbol of knowledge, achievement, and the passage into a new chapter. Inspired by her years studying in Milan, Nicole was deeply influenced by the cultural significance and quiet dignity of this emblem. It speaks to both personal triumph and continuity. Each piece carries this spirit of celebration, while remaining rooted in the beauty of everyday life.',
    'pine-nuts': 'Inspired by the view from Nicole\'s studio nestled in the Lebanese mountains, this collection echoes the organic shapes and textures of pine cones, earthy, sculptural forms rooted in memory and place.',
    'private-collections': 'The Private Collection is a tapestry of moments shared with remarkable people. It gathers pieces created for those who hold a special place in my life: family, friends, and special clients whose stories have shaped my hands as much as my clay. Each work carries its own quiet journey, born from personal moments, whispered inspirations, and the wish to create something felt deeply and uniquely for them. Shaped pieces that live beyond the object itself, each one holding a trace of the bond, emotion, and memory that inspired it.',
    'the-palm': 'Like the palm, they rise, petals that never fade, layered in timeless grace. Born from my days in Doha, these pieces breathe the warmth of its people, the serenity of its shores, and the generosity that surrounded me. They carry the glow of the golden desert sun, the calm breath of the sea, and the quiet poetry of tradition. Each layer holds a trace of hospitality and the memories shaped with family and friends.',
    'totem': 'Inspired by the idea of sacred objects that hold stories and identity, and created to bring warmth and soul to contemporary interiors, Totem pieces serve as sculptural anchors, distinctive forms that carry presence, personality, and quiet strength. More than decoration, they are designed to root a space, invite reflection, and hold emotional weight. They spark conversation, invite connection, and ground the home with a sense of meaning and intention.',
    'tribal-heritage': 'Tribal Heritage draws inspiration from Africa\'s vast landscapes and enduring traditions. Matte vessels reflect the textures of soil and sunlight, while curves and carvings echo desert dunes and ancient woven patterns. Each piece becomes a tactile story of resilience and timeless beauty.',
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    scrollToTop();
    setIsMenuOpen(false);
  };

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute('href');
    if (href) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  const openBookingWidget = (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    console.log('Opening order modal...');
    setShowOrderModal(true);
  };

  const collectionNames: Record<string, string> = {
    'bamboo-coral': 'Bamboo & Coral',
    'cactus': 'Cactus',
    'distorted-forms': 'Distorted Forms',
    'fish-scale': 'Fish Scale',
    'leaves': 'Leaves',
    'pine-nuts': 'Pine Nuts',
    'private-collections': 'Private Collections',
    'the-palm': 'The Palm',
    'totem': 'Totem',
    'tribal-heritage': 'Tribal Heritage'
  };

  const openImageModal = (imageSrc: string, collectionId?: string) => {
    setSelectedImage(imageSrc);
    setImageZoom(1);
    if (collectionId) {
      setSelectedImageCollection(collectionNames[collectionId] || '');
    } else {
      setSelectedImageCollection('');
    }
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    setSelectedImageCollection('');
    setImageZoom(1);
  };

  const navigateImage = (direction: 'prev' | 'next') => {
    if (!selectedImage) return;
    
    // Flatten all images into one array with collection info
    const allImagesWithCollections: Array<{ src: string; collection: string }> = [];
    Object.entries(collectionImages).forEach(([collectionId, images]) => {
      images.forEach(src => {
        allImagesWithCollections.push({ 
          src, 
          collection: collectionNames[collectionId] || '' 
        });
      });
    });
    
    const currentIndex = allImagesWithCollections.findIndex(img => img.src === selectedImage);
    let newIndex;
    
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % allImagesWithCollections.length;
    } else {
      newIndex = (currentIndex - 1 + allImagesWithCollections.length) % allImagesWithCollections.length;
    }
    
    setSelectedImage(allImagesWithCollections[newIndex].src);
    setSelectedImageCollection(allImagesWithCollections[newIndex].collection);
    setImageZoom(1);
  };

  // Get current image index and total count
  const getCurrentImageInfo = () => {
    if (!selectedImage) return { current: 0, total: 0 };
    
    const allImages: string[] = [];
    Object.values(collectionImages).forEach(images => {
      allImages.push(...images);
    });
    
    const currentIndex = allImages.findIndex(img => img === selectedImage);
    return {
      current: currentIndex + 1,
      total: allImages.length
    };
  };

  const handleWheel = (e: React.WheelEvent) => {
    e.preventDefault();
    const delta = e.deltaY > 0 ? -0.2 : 0.2;
    setImageZoom(prev => Math.min(Math.max(prev + delta, 0.5), 3));
  };

  const resetZoom = (e: React.MouseEvent) => {
    e.stopPropagation();
    setImageZoom(1);
  };

  const toggleFullscreen = (e: React.MouseEvent) => {
    e.stopPropagation();
    
    const modalElement = document.getElementById('image-modal');
    if (!modalElement) return;

    if (!document.fullscreenElement) {
      if (modalElement.requestFullscreen) {
        modalElement.requestFullscreen();
      } else if ((modalElement as any).webkitRequestFullscreen) {
        (modalElement as any).webkitRequestFullscreen();
      } else if ((document as any).msRequestFullscreen) {
        (document as any).msRequestFullscreen();
      }
      setIsFullscreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if ((document as any).webkitExitFullscreen) {
        (document as any).webkitExitFullscreen();
      } else if ((document as any).msExitFullscreen) {
        (document as any).msExitFullscreen();
      }
      setIsFullscreen(false);
    }
  };

  useEffect(() => {
    // Trigger hero animation on mount
    setTimeout(() => setHeroVisible(true), 100);

    const handleScroll = () => {
      const aboutSection = document.getElementById('about');
      if (aboutSection) {
        const rect = aboutSection.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Trigger animation when section is 30% visible
        if (rect.top < windowHeight * 0.7 && rect.bottom > 0) {
          setAboutTextVisible(true);
        }
        
        // Reset expanded state when scrolling away from About section
        if (rect.bottom < 0 || rect.top > windowHeight) {
          setAboutExpanded(false);
        }
      }

      // Gallery section animation
      const gallerySection = document.getElementById('gallery');
      if (gallerySection) {
        const rect = gallerySection.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        if (rect.top < windowHeight * 0.7 && rect.bottom > 0) {
          setGalleryVisible(true);
        }
      }

      // Bespoke section animation
      const bespokeSection = document.getElementById('bespoke');
      if (bespokeSection) {
        const rect = bespokeSection.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        if (rect.top < windowHeight * 0.7 && rect.bottom > 0) {
          setBespokeVisible(true);
        }
        
        if (rect.bottom < 0 || rect.top > windowHeight) {
          setBespokeExpanded(false);
        }
      }

      // Contact section animation
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        const rect = contactSection.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        if (rect.top < windowHeight * 0.7 && rect.bottom > 0) {
          setContactVisible(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on mount
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!selectedImage) return;
      
      if (e.key === 'ArrowLeft') {
        navigateImage('prev');
      } else if (e.key === 'ArrowRight') {
        navigateImage('next');
      } else if (e.key === 'Escape') {
        closeImageModal();
      } else if (e.key === 'f' || e.key === 'F') {
        e.preventDefault();
        const modalElement = document.getElementById('image-modal');
        if (modalElement) {
          const mockEvent = {
            stopPropagation: () => {}
          } as React.MouseEvent;
          toggleFullscreen(mockEvent);
        }
      }
    };

    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    window.addEventListener('keydown', handleKeyDown);
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);
    
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, [selectedImage]);

  // Get filtered gallery images
  const getFilteredGalleryImages = () => {
    return collectionImages[galleryFilter as keyof typeof collectionImages].map(src => ({
      src,
      collection: collectionNames[galleryFilter] || '',
      collectionId: galleryFilter
    }));
  };

  const filteredImages = getFilteredGalleryImages();

  const handleFilterChange = (e: React.MouseEvent, filterId: string) => {
    e.preventDefault();
    e.stopPropagation();
    setGalleryFilter(filterId);
  };

  const checkOrientation = () => {
    const isMobile = window.innerWidth <= 768;
    const isPortrait = window.innerHeight > window.innerWidth;
    
    setIsPortraitMode(isMobile && isPortrait);
  };

  useEffect(() => {
    checkOrientation();
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);
    
    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  // About section images array
  const aboutImages = [
    'https://readdy.ai/api/search-image?query=Portrait%20of%20elegant%20female%20potter%20in%20minimalist%20studio%20workspace%20professional%20ceramic%20artist%20with%20natural%20lighting%20contemporary%20pottery%20studio%20environment%20with%20clean%20aesthetic%20sophisticated%20fine%20art%20photography%20capturing%20artisan%20at%20work&width=600&height=700&seq=about-artist-portrait-v6&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Close-up%20of%20female%20potter%20hands%20shaping%20clay%20on%20pottery%20wheel%20in%20minimalist%20studio%20elegant%20feminine%20hands%20working%20with%20ceramic%20material%20artisan%20woman%20creating%20pottery%20with%20delicate%20touch%20soft%20natural%20lighting%20with%20clean%20white%20background%20professional%20fine%20art%20photography%20capturing%20female%20craftsmanship%20and%20dedication&width=600&height=700&seq=about-hands-pottery-v1&orientation=portrait',
    'https://readdy.ai/api/search-image?query=Beautiful%20ceramic%20studio%20workspace%20with%20handcrafted%20pottery%20pieces%20on%20wooden%20shelves%20minimalist%20artisan%20studio%20with%20natural%20light%20elegant%20ceramic%20vessels%20and%20tools%20contemporary%20pottery%20studio%20interior%20professional%20fine%20art%20photography&width=600&height=700&seq=about-studio-workspace-v1&orientation=portrait',
    'https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/4c1ead84eaffdf88aee579f7baa67472.jpeg'
  ];

  // Auto-rotate about images on mobile when expanded
  useEffect(() => {
    if (aboutExpanded && window.innerWidth < 768) {
      const interval = setInterval(() => {
        setCurrentAboutImageIndex((prevIndex) => (prevIndex + 1) % aboutImages.length);
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [aboutExpanded]);

  // Reset image index when collapsing
  useEffect(() => {
    if (!aboutExpanded) {
      setCurrentAboutImageIndex(0);
    }
  }, [aboutExpanded]);

  // Color mapping for background colors
  const colorMap: Record<string, string> = {
    'Sage Green': '#8FA88E',
    'Eucalyptus Green': '#748474',
    'Terracotta': '#C4735A',
    'Coral Pink': '#F88379',
    'Warm Beige': '#D4C5B9',
    'Ivory Cream': '#FFFFF0',
    'Soft Grey': '#C0C0C0',
    'Dusty Rose': '#DCAE96',
    'Olive Green': '#808000',
    'Burnt Sienna': '#E97451',
    'Sand Beige': '#D2B48C',
    'Charcoal': '#36454F',
    'Warm White': '#FAF0E6',
    'Honey Yellow': '#F0C05A',
    'Ocean Blue': '#4F97A3',
    'Lavender': '#B57EDC',
    'Rust Orange': '#B7410E',
    'Mint Cream': '#B8E6D5',
    'Cream': '#FFFDD0',
    'Taupe': '#B38B6D',
    'Teal': '#008080',
    'Navy Blue': '#000080',
    'Forest Green': '#228B22',
    'Blush Pink': '#FFC0CB',
    'Mustard Yellow': '#FFDB58',
    'Slate Blue': '#6A5ACD',
    'Silver': '#C0C0C0',
    'Black': '#000000',
    'Brick Red': '#CB4154',
  };

  const colorOptions = [
    { name: 'Select Color Preference', value: '', color: '#F5F1E8', darkText: false },
    
    // Whites & Creams (Lightest)
    { name: 'Warm White', value: 'Warm White', color: '#FAF0E6', darkText: false },
    { name: 'Ivory Cream', value: 'Ivory Cream', color: '#FFFFF0', darkText: false },
    { name: 'Cream', value: 'Cream', color: '#FFFDD0', darkText: false },
    { name: 'Soft Grey', value: 'Soft Grey', color: '#C0C0C0', darkText: false },
    
    // Beiges & Taupes
    { name: 'Warm Beige', value: 'Warm Beige', color: '#D4C5B9', darkText: false },
    { name: 'Sand Beige', value: 'Sand Beige', color: '#D2B48C', darkText: false },
    { name: 'Taupe', value: 'Taupe', color: '#B38B6D', darkText: false },
    { name: 'Dusty Rose', value: 'Dusty Rose', color: '#DCAE96', darkText: false },
    
    // Pinks & Roses
    { name: 'Blush Pink', value: 'Blush Pink', color: '#FFC0CB', darkText: false },
    { name: 'Coral Pink', value: 'Coral Pink', color: '#F88379', darkText: false },
    
    // Reds
    { name: 'Brick Red', value: 'Brick Red', color: '#CB4154', darkText: false },
    
    // Yellows & Oranges
    { name: 'Honey Yellow', value: 'Honey Yellow', color: '#F0C05A', darkText: false },
    { name: 'Mustard Yellow', value: 'Mustard Yellow', color: '#FFDB58', darkText: false },
    { name: 'Burnt Sienna', value: 'Burnt Sienna', color: '#E97451', darkText: false },
    { name: 'Rust Orange', value: 'Rust Orange', color: '#B7410E', darkText: false },
    { name: 'Terracotta', value: 'Terracotta', color: '#C4735A', darkText: false },
    
    // Greens
    { name: 'Mint Cream', value: 'Mint Cream', color: '#B8E6D5', darkText: false },
    { name: 'Sage Green', value: 'Sage Green', color: '#8FA88E', darkText: false },
    { name: 'Eucalyptus Green', value: 'Eucalyptus Green', color: '#748474', darkText: false },
    { name: 'Olive Green', value: 'Olive Green', color: '#808000', darkText: false },
    { name: 'Forest Green', value: 'Forest Green', color: '#228B22', darkText: false },
    
    // Blues & Teals
    { name: 'Teal', value: 'Teal', color: '#008080', darkText: false },
    { name: 'Ocean Blue', value: 'Ocean Blue', color: '#4F97A3', darkText: false },
    { name: 'Slate Blue', value: 'Slate Blue', color: '#6A5ACD', darkText: false },
    { name: 'Lavender', value: 'Lavender', color: '#B57EDC', darkText: false },
    { name: 'Navy Blue', value: 'Navy Blue', color: '#000080', darkText: false },
    
    // Greys & Darks
    { name: 'Silver', value: 'Silver', color: '#C0C0C0', darkText: false },
    { name: 'Charcoal', value: 'Charcoal', color: '#36454F', darkText: false },
    { name: 'Black', value: 'Black', color: '#000000', darkText: false },
    
    // Custom Option
    { name: 'Custom Color (Specify in Details)', value: 'Custom Color (Specify in Details)', color: '#F5F1E8', darkText: false },
  ];

  const collectionOptions = [
    'Bamboo & Coral',
    'Cactus',
    'Distorted Forms',
    'Fish Scale',
    'Leaves',
    'Pine Nuts',
    'Private Collections',
    'The Palm',
    'Totem',
    'Tribal Heritage'
  ];

  const sizeOptions = ['Small', 'Medium', 'Large'];

  const glazeOptions = ['Matte Glaze', 'Glossy Glaze'];

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest('.color-dropdown-container')) {
        setIsColorDropdownOpen(false);
      }
      if (!target.closest('.collection-dropdown-container')) {
        setIsCollectionDropdownOpen(false);
      }
      if (!target.closest('.size-dropdown-container')) {
        setIsSizeDropdownOpen(false);
      }
      if (!target.closest('.glaze-dropdown-container')) {
        setIsGlazeDropdownOpen(false);
      }
    };

    if (isColorDropdownOpen || isCollectionDropdownOpen || isSizeDropdownOpen || isGlazeDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isColorDropdownOpen, isCollectionDropdownOpen, isSizeDropdownOpen, isGlazeDropdownOpen]);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const nav = document.querySelector('nav');
      if (isMenuOpen && nav && !nav.contains(target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setContactFormStatus('submitting');

    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d4kec9jka9995f28qrsg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setContactFormStatus('success');
        form.reset();
        setTimeout(() => setContactFormStatus('idle'), 3000);
      } else {
        setContactFormStatus('error');
        setTimeout(() => setContactFormStatus('idle'), 3000);
      }
    } catch (error) {
      setContactFormStatus('error');
      setTimeout(() => setContactFormStatus('idle'), 3000);
    }
  };

  const handleOrderSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setOrderFormStatus('submitting');

    const formData = new FormData(e.currentTarget);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d4keefd54aio6i8gemr0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setOrderFormStatus('success');
        e.currentTarget.reset();
        setSelectedColor('');
        setSelectedCollection('');
        setSelectedSize('');
        setSelectedGlaze('');
        setOrderDetailsLength(0);
        setTimeout(() => {
          setOrderFormStatus('idle');
          setShowOrderModal(false);
        }, 2000);
      } else {
        setOrderFormStatus('error');
        setTimeout(() => setOrderFormStatus('idle'), 3000);
      }
    } catch (error) {
      setOrderFormStatus('error');
      setTimeout(() => setOrderFormStatus('idle'), 3000);
    }
  };

  return (
    <div className="min-h-screen bg-logo-beige-50">
      {/* Navigation - Fully Responsive with Mobile Menu */}
      <nav className="fixed top-0 left-0 right-0 bg-logo-beige-50/95 backdrop-blur-sm z-50 border-b border-gray-100 transition-all duration-300">
        <div className="w-full px-3 sm:px-4 md:px-6 lg:px-8 xl:px-12">
          <div className="flex justify-between items-center py-3 sm:py-4 md:py-4 lg:py-5">
            {/* Brand Name Section - Left Side - Always visible */}
            <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0 min-w-0 relative z-[70]">
              <h1 
                className="text-xs xs:text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl tracking-wider sm:tracking-widest font-black text-sage-500 hover:text-sage-600 transition-colors uppercase title-font cursor-pointer whitespace-nowrap truncate relative z-[70]" 
                onClick={handleLogoClick}
              >
                Nicole Abou Farhat
              </h1>
            </div>

            {/* Mobile Menu Button + Logo - Right Side - Mobile Only */}
            <div className="xl:hidden flex items-center gap-2 sm:gap-3 relative z-[70]">
              {/* Mobile Logo - Interactive */}
              <div 
                className="flex-shrink-0 cursor-pointer transition-opacity hover:opacity-70" 
                onClick={handleLogoClick}
              >
                <img 
                  src="https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/c62b82255bfef8e3561b81f311409197.png"
                  alt="Nicole Abou Farhat Logo"
                  className="h-10 xs:h-11 sm:h-12 md:h-13 lg:h-14 w-auto cursor-pointer relative z-[70]"
                />
              </div>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center text-sage-500 hover:text-sage-600 transition-colors cursor-pointer flex-shrink-0"
                aria-label="Toggle menu"
              >
                <i className={`text-2xl sm:text-3xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </button>
            </div>
            
            {/* Desktop Navigation - Hidden on Mobile and Tablet */}
            <div className="hidden xl:flex items-center gap-3 2xl:gap-6 flex-shrink-0 relative z-[70]">
              <a href="#gallery" onClick={handleNavClick} className="text-xs sm:text-sm md:text-base lg:text-sm xl:text-lg tracking-wider text-sage-500 hover:text-sage-600 transition-colors cursor-pointer uppercase whitespace-nowrap font-black">Collection</a>
              <a href="#bespoke" onClick={handleNavClick} className="text-xs sm:text-sm md:text-base lg:text-sm xl:text-lg tracking-wider text-sage-500 hover:text-sage-600 transition-colors cursor-pointer uppercase whitespace-nowrap font-black">Made-to-Order</a>
              <a href="#about" onClick={handleNavClick} className="text-xs sm:text-sm md:text-base lg:text-sm xl:text-lg tracking-wider text-sage-500 hover:text-sage-600 transition-colors cursor-pointer uppercase whitespace-nowrap font-black">About</a>
              <a href="#contact" onClick={handleNavClick} className="text-xs sm:text-sm md:text-base lg:text-sm xl:text-lg tracking-wider text-sage-500 hover:text-sage-600 transition-colors cursor-pointer uppercase whitespace-nowrap font-black">Contact</a>
              <div className="flex-shrink-0 cursor-pointer transition-opacity hover:opacity-70 ml-2" onClick={handleLogoClick}>
                <img 
                  src="https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/c62b82255bfef8e3561b81f311409197.png"
                  alt="Nicole Abou Farhat Logo"
                  className="h-10 xs:h-11 sm:h-12 md:h-13 lg:h-14 xl:h-16 w-auto cursor-pointer relative z-[70]"
                />
              </div>
            </div>
          </div>

          {/* Mobile Menu Dropdown - Improved spacing and touch targets */}
          {isMenuOpen && (
            <div className="xl:hidden border-t border-gray-100 py-3 sm:py-4 space-y-1 relative z-[70]">
              <a 
                href="#gallery" 
                onClick={handleNavClick}
                className="block text-sm sm:text-base md:text-lg tracking-wider text-sage-500 hover:text-sage-600 transition-colors cursor-pointer uppercase whitespace-nowrap font-black py-3 px-2"
              >
                Collection
              </a>
              <a 
                href="#bespoke" 
                onClick={handleNavClick}
                className="block text-sm sm:text-base md:text-lg tracking-wider text-sage-500 hover:text-sage-600 transition-colors cursor-pointer uppercase whitespace-nowrap font-black py-3 px-2"
              >
                Made-to-Order
              </a>
              <a 
                href="#about" 
                onClick={handleNavClick}
                className="block text-sm sm:text-base md:text-lg tracking-wider text-sage-500 hover:text-sage-600 transition-colors cursor-pointer uppercase whitespace-nowrap font-black py-3 px-2"
              >
                About
              </a>
              <a 
                href="#contact" 
                onClick={handleNavClick}
                className="block text-sm sm:text-base md:text-lg tracking-wider text-sage-500 hover:text-sage-600 transition-colors cursor-pointer uppercase whitespace-nowrap font-black py-3 px-2"
              >
                Contact
              </a>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section - Responsive height with fade-in animation */}
      <section className={`relative h-[60vh] sm:h-[70vh] md:h-[80vh] lg:h-screen flex items-center justify-center pt-16 sm:pt-20 md:pt-24 transition-all duration-1000 ${heroVisible ? 'opacity-100' : 'opacity-0'}`}>
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/f8643a4e1031fabd9020fdc175fb59b1.jpeg"
            alt="Studio"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-white/20"></div>
        </div>
      </section>

      {/* Gallery Section - Filterable with Dynamic Text and animations */}
      <section id="gallery" className={`py-16 sm:py-24 bg-logo-beige-50 transition-all duration-800 ${galleryVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} data-product-shop>
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-12 sm:mb-16 animate-fadeIn">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-sage-500 mb-12 sm:mb-14 md:mb-16 tracking-widest uppercase text-center">COLLECTION</h2>
            <p className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light max-w-none mx-auto text-left hyphens-auto" style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
              Each collection is born from a moment, a memory, a place, a feeling. Whether inspired by nature, travel, or the quiet intimacy of everyday life, Nicole's creations carry a story. Guided by her sensibility, they form a personal and evolving landscape, where form, texture, and colour reflect the world as she experiences it, vibrant, imperfect, and deeply&nbsp;human.
            </p>
          </div>

          {/* Filter Buttons with stagger animation */}
          <div className="flex flex-wrap justify-center gap-3 mb-12 animate-fadeIn-delay-1">
            {Object.entries(collectionNames).map(([id, name]) => (
              <button
                key={id}
                onClick={(e) => handleFilterChange(e, id)}
                onDoubleClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                className={`px-6 py-2 rounded-full text-sm tracking-wider uppercase whitespace-nowrap cursor-pointer transition-colors text-center select-none ${
                  galleryFilter === id
                    ? 'bg-sage-500 text-white'
                    : 'bg-logo-beige-50 text-sage-500 border-2 border-sage-500 hover:bg-sage-500 hover:text-white'
                }`}
              >
                {name}
              </button>
            ))}
          </div>

          {/* Gallery Grid with stagger animation */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 animate-fadeIn-delay-2">
            {/* Mobile & Tablet: 2 images on left (1/2), text on right (1/2) */}
            <div className="md:hidden grid grid-cols-2 gap-4">
              {/* Left side: 2 images vertically stacked */}
              <div className="space-y-4">
                {filteredImages.slice(0, 2).map((image, index) => (
                  <div
                    key={`${galleryFilter}-mobile-${index}`}
                    className="relative group cursor-pointer overflow-hidden bg-gray-50"
                    onClick={() => openImageModal(image.src, galleryFilter)}
                  >
                    <img
                      src={image.src}
                      alt={`${image.collection} - Image ${index + 1}`}
                      className="w-full h-48 object-cover object-top transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300"></div>
                  </div>
                ))}
              </div>
              
              {/* Right side: Collection name and description - vertically centered */}
              <div className="flex flex-col justify-center">
                <h3 className="text-base font-bold text-sage-500 mb-3 text-center uppercase tracking-widest">{collectionNames[galleryFilter]}</h3>
                <p className="text-sm text-sage-700 font-light leading-relaxed text-justify hyphens-auto">
                  {collectionDescriptions[galleryFilter]}
                </p>
              </div>
            </div>

            {/* Desktop: Show all images when expanded, first image when collapsed */}
            <div className="hidden md:block md:col-span-2">
              <div className="grid grid-cols-3 gap-4">
                {filteredImages.map((image, index) => (
                  <div
                    key={`${galleryFilter}-${index}`}
                    className="relative group cursor-pointer overflow-hidden bg-gray-50"
                    onClick={() => openImageModal(image.src, galleryFilter)}
                  >
                    <img
                      src={image.src}
                      alt={`${image.collection} - Image ${index + 1}`}
                      className="w-full h-48 sm:h-56 md:h-64 object-cover object-top transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300"></div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Desktop: Collection name and description taking 1/3 of page, vertically centered */}
            <div className="hidden md:flex md:col-span-1 flex-col justify-center pl-4">
              <h3 className="text-lg sm:text-xl font-bold text-sage-500 mb-4 text-center uppercase tracking-widest">{collectionNames[galleryFilter]}</h3>
              <p className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light leading-relaxed text-justify hyphens-auto">
                {collectionDescriptions[galleryFilter]}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          id="image-modal"
          className="fixed inset-0 bg-logo-beige-50 z-[100] flex items-center justify-center p-4 overflow-hidden"
          onClick={closeImageModal}
        >
          {/* Close Button - Top Right */}
          <button
            onClick={closeImageModal}
            className="fixed top-4 sm:top-6 right-4 sm:right-6 text-sage-500 hover:text-sage-600 transition-colors z-[110] cursor-pointer bg-logo-beige-50 border-2 border-logo-beige-300 hover:border-sage-500 rounded-full w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center shadow-lg"
            title="Close (ESC)"
          >
            <i className="ri-close-line text-2xl sm:text-3xl"></i>
          </button>

          {/* Collection Name Display - Top Center */}
          {selectedImageCollection && (
            <div className="fixed top-4 sm:top-6 left-1/2 -translate-x-1/2 text-sage-500 bg-logo-beige-50 border-2 border-logo-beige-300 px-4 sm:px-6 py-2 rounded-full text-base sm:text-lg font-bold z-[110] shadow-lg max-w-[60%] text-center uppercase tracking-widest">
              {selectedImageCollection}
            </div>
          )}

          {/* Control Buttons - Top Left */}
          <div className="fixed top-4 sm:top-6 left-4 sm:left-6 flex flex-col gap-2 z-[110]">
            <button
              onClick={resetZoom}
              className="text-sage-500 hover:text-sage-600 transition-colors cursor-pointer bg-logo-beige-50 border-2 border-logo-beige-300 hover:border-sage-500 rounded-full w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center shadow-lg"
              title="Reset Zoom (100%)"
            >
              <i className="ri-zoom-in-line text-2xl sm:text-3xl"></i>
            </button>
            <button
              onClick={toggleFullscreen}
              className="text-sage-500 hover:text-sage-600 transition-colors cursor-pointer bg-logo-beige-50 border-2 border-logo-beige-300 hover:border-sage-500 rounded-full w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center shadow-lg"
              title={isFullscreen ? "Exit Fullscreen (F)" : "Enter Fullscreen (F)"}
            >
              <i className={`text-xl sm:text-2xl ${isFullscreen ? 'ri-fullscreen-exit-line' : 'ri-fullscreen-line'}`}></i>
            </button>
          </div>

          {/* Previous Button - Left Center */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('prev');
            }}
            className="fixed left-4 sm:left-6 top-1/2 -translate-y-1/2 text-sage-500 hover:text-sage-600 transition-colors z-[110] cursor-pointer bg-logo-beige-50 border-2 border-logo-beige-300 hover:border-sage-500 rounded-full w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center shadow-lg"
            title="Previous Image (←)"
          >
            <i className="ri-arrow-left-s-line text-2xl sm:text-3xl"></i>
          </button>

          {/* Next Button - Right Center */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('next');
            }}
            className="fixed right-4 sm:right-6 top-1/2 -translate-y-1/2 text-sage-500 hover:text-sage-600 transition-colors z-[110] cursor-pointer bg-logo-beige-50 border-2 border-logo-beige-300 hover:border-sage-500 rounded-full w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center shadow-lg"
            title="Next Image (→)"
          >
            <i className="ri-arrow-right-s-line text-2xl sm:text-3xl"></i>
          </button>

          {/* Zoom Level Indicator - Bottom Left */}
          <div className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 text-sage-500 bg-logo-beige-50 border-2 border-logo-beige-300 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-base sm:text-lg font-bold z-[110] shadow-lg">
            {Math.round(imageZoom * 100)}%
          </div>

          {/* Image Counter - Bottom Center */}
          <div className="fixed bottom-4 sm:bottom-6 left-1/2 -translate-x-1/2 text-sage-500 bg-logo-beige-50 border-2 border-logo-beige-300 px-4 sm:px-6 py-1.5 sm:py-2 rounded-full text-base sm:text-lg font-bold z-[110] shadow-lg">
            {getCurrentImageInfo().current}/{getCurrentImageInfo().total}
          </div>

          {/* Image Container - Centered with proper constraints */}
          <div 
            className="relative flex items-center justify-center w-full h-full"
            onClick={(e) => e.stopPropagation()}
            onWheel={handleWheel}
          >
            <img 
              src={selectedImage}
              alt="Gallery Image"
              className="block transition-transform duration-300 ease-out cursor-grab active:cursor-grabbing object-contain"
              style={{ 
                transform: `scale(${imageZoom})`,
                transformOrigin: 'center center',
                maxWidth: '90vw',
                maxHeight: '90vh',
                width: 'auto',
                height: 'auto'
              }}
              draggable={false}
              onDoubleClick={() => setImageZoom(prev => Math.min(prev + 0.5, 3))}
            />
          </div>
        </div>
      )}

      {/* Made-to-Order Section with animations */}
      <section id="bespoke" className={`py-16 sm:py-24 bg-logo-beige-50 transition-all duration-800 ${bespokeVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
        <div className="max-w-5xl mx-auto px-6 lg:px-12">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-sage-500 mb-8 sm:mb-12 tracking-widest uppercase text-center animate-fadeIn">MADE-TO-ORDER</h2>
          
          {/* Visual Process Timeline with stagger animation */}
          <div className="mb-12 sm:mb-16 animate-fadeIn-delay-1">
            <h3 className="text-2xl sm:text-3xl font-light text-sage-500 mb-12 sm:mb-14 md:mb-16 tracking-tight text-center">
              The Journey of Your Piece
            </h3>
            
            {/* Desktop Layout - Horizontal without timeline */}
            <div className="hidden md:block relative max-w-6xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-6 gap-8 md:gap-6">
                {/* Step 1: Handcrafted */}
                <div className="flex flex-col items-center text-center group cursor-pointer relative">
                  <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-logo-beige-100 border-2 border-sage-300 flex items-center justify-center mb-4 relative z-10 transition-all duration-300 group-hover:scale-110 group-hover:bg-sage-500 group-hover:border-sage-500 group-hover:shadow-lg">
                    <i className="ri-hand-heart-line text-3xl sm:text-4xl text-sage-500 transition-colors duration-300 group-hover:text-white"></i>
                  </div>
                  <h4 className="text-sm sm:text-base font-semibold text-sage-500 mb-2 uppercase tracking-wider transition-colors duration-300 group-hover:text-sage-600">Handcrafted</h4>
                  <p className="text-sm sm:text-base text-sage-700 font-normal leading-tight opacity-0 max-h-0 overflow-hidden transition-all duration-300 group-hover:opacity-100 group-hover:max-h-20">
                    Wheel or Hand-Building
                  </p>
                </div>

                {/* Step 2: Drying */}
                <div className="flex flex-col items-center text-center group cursor-pointer relative">
                  <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-logo-beige-100 border-2 border-sage-300 flex items-center justify-center mb-4 relative z-10 transition-all duration-300 group-hover:scale-110 group-hover:bg-sage-500 group-hover:border-sage-500 group-hover:shadow-lg">
                    <i className="ri-time-line text-3xl sm:text-4xl text-sage-500 transition-colors duration-300 group-hover:text-white"></i>
                  </div>
                  <h4 className="text-sm sm:text-base font-semibold text-sage-500 mb-2 uppercase tracking-wider transition-colors duration-300 group-hover:text-sage-600">Drying</h4>
                  <p className="text-sm sm:text-base text-sage-700 font-normal leading-tight opacity-0 max-h-0 overflow-hidden transition-all duration-300 group-hover:opacity-100 group-hover:max-h-20">
                    Slowly dries to bone dry
                  </p>
                </div>

                {/* Step 3: Bisque Firing */}
                <div className="flex flex-col items-center text-center group cursor-pointer relative">
                  <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-logo-beige-100 border-2 border-sage-300 flex items-center justify-center mb-4 relative z-10 transition-all duration-300 group-hover:scale-110 group-hover:bg-sage-500 group-hover:border-sage-500 group-hover:shadow-lg">
                    <i className="ri-fire-line text-3xl sm:text-4xl text-sage-500 transition-colors duration-300 group-hover:text-white"></i>
                  </div>
                  <h4 className="text-sm sm:text-base font-semibold text-sage-500 mb-2 uppercase tracking-wider transition-colors duration-300 group-hover:text-sage-600">Bisque Firing</h4>
                  <p className="text-sm sm:text-base text-sage-700 font-normal leading-tight opacity-0 max-h-0 overflow-hidden transition-all duration-300 group-hover:opacity-100 group-hover:max-h-20">
                    First firing in the kiln
                  </p>
                </div>

                {/* Step 4: Glazing */}
                <div className="flex flex-col items-center text-center group cursor-pointer relative">
                  <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-logo-beige-100 border-2 border-sage-300 flex items-center justify-center mb-4 relative z-10 transition-all duration-300 group-hover:scale-110 group-hover:bg-sage-500 group-hover:border-sage-500 group-hover:shadow-lg">
                    <i className="ri-palette-line text-3xl sm:text-4xl text-sage-500 transition-colors duration-300 group-hover:text-white"></i>
                  </div>
                  <h4 className="text-sm sm:text-base font-semibold text-sage-500 mb-2 uppercase tracking-wider transition-colors duration-300 group-hover:text-sage-600">Glazing</h4>
                  <p className="text-sm sm:text-base text-sage-700 font-normal leading-tight opacity-0 max-h-0 overflow-hidden transition-all duration-300 group-hover:opacity-100 group-hover:max-h-20">
                    Painterly colour application
                  </p>
                </div>

                {/* Step 5: Glaze Firing */}
                <div className="flex flex-col items-center text-center group cursor-pointer relative">
                  <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-logo-beige-100 border-2 border-sage-300 flex items-center justify-center mb-4 relative z-10 transition-all duration-300 group-hover:scale-110 group-hover:bg-sage-500 group-hover:border-sage-500 group-hover:shadow-lg">
                    <i className="ri-fire-fill text-3xl sm:text-4xl text-sage-500 transition-colors duration-300 group-hover:text-white"></i>
                  </div>
                  <h4 className="text-sm sm:text-base font-semibold text-sage-500 mb-2 uppercase tracking-wider transition-colors duration-300 group-hover:text-sage-600">Glaze Firing</h4>
                  <p className="text-sm sm:text-base text-sage-700 font-normal leading-tight opacity-0 max-h-0 overflow-hidden transition-all duration-300 group-hover:opacity-100 group-hover:max-h-20">
                    Second firing, high-fire stage
                  </p>
                </div>

                {/* Step 6: Delivery */}
                <div className="flex flex-col items-center text-center group cursor-pointer">
                  <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-logo-beige-100 border-2 border-sage-300 flex items-center justify-center mb-4 relative z-10 transition-all duration-300 group-hover:scale-110 group-hover:bg-sage-500 group-hover:border-sage-500 group-hover:shadow-lg">
                    <i className="ri-gift-line text-3xl sm:text-4xl text-sage-500 transition-colors duration-300 group-hover:text-white"></i>
                  </div>
                  <h4 className="text-sm sm:text-base font-semibold text-sage-500 mb-2 uppercase tracking-wider transition-colors duration-300 group-hover:text-sage-600">Delivery</h4>
                  <p className="text-sm sm:text-base text-sage-700 font-normal leading-tight opacity-0 max-h-0 overflow-hidden transition-all duration-300 group-hover:opacity-100 group-hover:max-h-20">
                    Photos, packaging & shipping
                  </p>
                </div>
              </div>
            </div>

            {/* Mobile Layout - 3 Rows, 2 Icons Each, No Arrows */}
            <div className="md:hidden max-w-sm mx-auto space-y-8">
              {/* Row 1: Handcrafted → Drying */}
              <div className="flex items-center justify-around">
                {/* Step 1: Handcrafted */}
                <div className="flex flex-col items-center text-center group cursor-pointer w-32">
                  <div className="w-16 h-16 rounded-full bg-logo-beige-100 border-2 border-sage-300 flex items-center justify-center mb-2 relative z-10 transition-all duration-300 group-hover:scale-110 group-hover:bg-sage-500 group-hover:border-sage-500 group-hover:shadow-lg">
                    <i className="ri-hand-heart-line text-2xl text-sage-500 transition-colors duration-300 group-hover:text-white"></i>
                  </div>
                  <h4 className="text-xs font-semibold text-sage-500 mb-1 uppercase tracking-wider transition-colors duration-300 group-hover:text-sage-600">Handcrafted</h4>
                  <p className="text-xs text-sage-700 font-normal leading-tight opacity-0 max-h-0 overflow-hidden transition-all duration-300 group-hover:opacity-100 group-hover:max-h-20">
                    Wheel or Hand-Building
                  </p>
                </div>

                {/* Step 2: Drying */}
                <div className="flex flex-col items-center text-center group cursor-pointer w-32">
                  <div className="w-16 h-16 rounded-full bg-logo-beige-100 border-2 border-sage-300 flex items-center justify-center mb-2 relative z-10 transition-all duration-300 group-hover:scale-110 group-hover:bg-sage-500 group-hover:border-sage-500 group-hover:shadow-lg">
                    <i className="ri-time-line text-2xl text-sage-500 transition-colors duration-300 group-hover:text-white"></i>
                  </div>
                  <h4 className="text-xs font-semibold text-sage-500 mb-1 uppercase tracking-wider transition-colors duration-300 group-hover:text-sage-600">Drying</h4>
                  <p className="text-xs text-sage-700 font-normal leading-tight opacity-0 max-h-0 overflow-hidden transition-all duration-300 group-hover:opacity-100 group-hover:max-h-20">
                    Slowly dries to bone dry
                  </p>
                </div>
              </div>

              {/* Row 2: Bisque Firing → Glazing */}
              <div className="flex items-center justify-around">
                {/* Step 3: Bisque Firing */}
                <div className="flex flex-col items-center text-center group cursor-pointer w-32">
                  <div className="w-16 h-16 rounded-full bg-logo-beige-100 border-2 border-sage-300 flex items-center justify-center mb-2 relative z-10 transition-all duration-300 group-hover:scale-110 group-hover:bg-sage-500 group-hover:border-sage-500 group-hover:shadow-lg">
                    <i className="ri-fire-line text-2xl text-sage-500 transition-colors duration-300 group-hover:text-white"></i>
                  </div>
                  <h4 className="text-xs font-semibold text-sage-500 mb-1 uppercase tracking-wider transition-colors duration-300 group-hover:text-sage-600">Bisque Firing</h4>
                  <p className="text-xs text-sage-700 font-normal leading-tight opacity-0 max-h-0 overflow-hidden transition-all duration-300 group-hover:opacity-100 group-hover:max-h-20">
                    First firing in the kiln
                  </p>
                </div>

                {/* Step 4: Glazing */}
                <div className="flex flex-col items-center text-center group cursor-pointer w-32">
                  <div className="w-16 h-16 rounded-full bg-logo-beige-100 border-2 border-sage-300 flex items-center justify-center mb-2 relative z-10 transition-all duration-300 group-hover:scale-110 group-hover:bg-sage-500 group-hover:border-sage-500 group-hover:shadow-lg">
                    <i className="ri-palette-line text-2xl text-sage-500 transition-colors duration-300 group-hover:text-white"></i>
                  </div>
                  <h4 className="text-xs font-semibold text-sage-500 mb-1 uppercase tracking-wider transition-colors duration-300 group-hover:text-sage-600">Glazing</h4>
                  <p className="text-xs text-sage-700 font-normal leading-tight opacity-0 max-h-0 overflow-hidden transition-all duration-300 group-hover:opacity-100 group-hover:max-h-20">
                    Painterly colour application
                  </p>
                </div>
              </div>

              {/* Row 3: Glaze Firing → Delivery */}
              <div className="flex items-center justify-around">
                {/* Step 5: Glaze Firing */}
                <div className="flex flex-col items-center text-center group cursor-pointer w-32">
                  <div className="w-16 h-16 rounded-full bg-logo-beige-100 border-2 border-sage-300 flex items-center justify-center mb-2 relative z-10 transition-all duration-300 group-hover:scale-110 group-hover:bg-sage-500 group-hover:border-sage-500 group-hover:shadow-lg">
                    <i className="ri-fire-fill text-2xl text-sage-500 transition-colors duration-300 group-hover:text-white"></i>
                  </div>
                  <h4 className="text-xs font-semibold text-sage-500 mb-1 uppercase tracking-wider transition-colors duration-300 group-hover:text-sage-600">Glaze Firing</h4>
                  <p className="text-xs text-sage-700 font-normal leading-tight opacity-0 max-h-0 overflow-hidden transition-all duration-300 group-hover:opacity-100 group-hover:max-h-20">
                    Second firing, high-fire stage
                  </p>
                </div>

                {/* Step 6: Delivery */}
                <div className="flex flex-col items-center text-center group cursor-pointer w-32">
                  <div className="w-16 h-16 rounded-full bg-logo-beige-100 border-2 border-sage-300 flex items-center justify-center mb-2 relative z-10 transition-all duration-300 group-hover:scale-110 group-hover:bg-sage-500 group-hover:border-sage-500 group-hover:shadow-lg">
                    <i className="ri-gift-line text-2xl text-sage-500 transition-colors duration-300 group-hover:text-white"></i>
                  </div>
                  <h4 className="text-xs font-semibold text-sage-500 mb-1 uppercase tracking-wider transition-colors duration-300 group-hover:text-sage-600">Delivery</h4>
                  <p className="text-xs text-sage-700 font-normal leading-tight opacity-0 max-h-0 overflow-hidden transition-all duration-300 group-hover:opacity-100 group-hover:max-h-20">
                    Photos, packaging & shipping
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Full width introductory text with animation */}
          <div className="mb-8 sm:mb-12 animate-fadeIn-delay-2">
            <p className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light leading-relaxed mb-4 sm:mb-6 text-justify hyphens-auto">
              Bespoke projects invite creative dialogue and thoughtful collaboration, an opportunity to craft something&nbsp;truly&nbsp;unique.
            </p>
            
            <p className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light leading-relaxed text-justify hyphens-auto">
              Whether you're envisioning a sculptural statement, a meaningful gift, or a piece tailored to a specific space, each creation is shaped with care&nbsp;and&nbsp;intention.
            </p>
          </div>

          {/* Two-column layout with image on left (1/3) and text on right (2/3) with animation */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 sm:gap-12 mb-12 sm:mb-16 animate-fadeIn-delay-3">
            <div className="lg:col-span-1">
              <img 
                src="https://readdy.ai/api/search-image?query=Close-up%20of%20female%20potter%20woman%20hands%20shaping%20clay%20on%20pottery%20wheel%20in%20minimalist%20studio%20elegant%20feminine%20hands%20working%20with%20ceramic%20material%20artisan%20woman%20creating%20pottery%20with%20delicate%20touch%20soft%20natural%20lighting%20with%20clean%20white%20background%20professional%20fine%20art%20photography%20capturing%20female%20craftsmanship%20and%20dedication&width=600&height=700&seq=bespoke-female-hands-v6&orientation=portrait"
                alt="Bespoke Process"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="lg:col-span-2">
              <p className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light leading-relaxed mb-3 sm:mb-4">
                Custom work&nbsp;may&nbsp;include:
              </p>
              
              <ul className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light leading-relaxed space-y-2 pl-4 sm:pl-6">
                <li>- Unique vases, candle holders, and sculptural forms <span className="italic">(from small to&nbsp;large&nbsp;scale)</span></li>
                <li>- Ceramic lighting <span className="italic">(table lamps, wall fixtures, pendants,&nbsp;floor&nbsp;lamps)</span></li>
                <li>- Wall panels or&nbsp;ceramic&nbsp;compositions</li>
                <li>- Site-specific pieces for interiors, hospitality, or&nbsp;cultural&nbsp;spaces</li>
              </ul>
              
              <p className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light leading-relaxed mb-4 sm:mb-6">
                These pieces can be created for a range of special occasions, from weddings, baptisms, and first communions to Mother's Day, Christmas, or corporate gifting, offering a lasting and personal expression&nbsp;of&nbsp;celebration.
              </p>
              
              <p className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light leading-relaxed">
                To explore a project or discuss an idea, feel free to get in touch via the contact form or&nbsp;by&nbsp;email.
              </p>
            </div>
          </div>

          {/* PROCESS Button - Now appears right after the "get in touch" sentence */}
          {!bespokeExpanded && (
            <div className="text-center mb-12 sm:mb-16">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setBespokeExpanded(true);
                }}
                className="inline-flex items-center gap-2 px-8 py-3 border-2 border-sage-500 text-sage-500 hover:bg-sage-500 hover:text-white transition-colors text-sm tracking-widest uppercase whitespace-nowrap cursor-pointer rounded-full"
              >
                PROCESS
                <i className="ri-arrow-down-s-line text-xl"></i>
              </button>
            </div>
          )}

          {/* Process details - Only shown when expanded */}
          {bespokeExpanded && (
            <div className="space-y-6 sm:space-y-8 mb-12 sm:mb-16">
              <div>
                <h3 className="text-2xl sm:text-3xl font-light text-sage-500 mb-3 sm:mb-4 tracking-tight">Process</h3>
                <p className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light leading-relaxed text-justify hyphens-auto">
                  Every bespoke project begins with a conversation, a shared sense of atmosphere, texture, or intention. Whether sparked by reference images, materials, or a simple mood, ideas are translated through sketches, tests, and intuitive exploration. Each piece is shaped entirely by hand, allowing for natural variations in tone and form. While no two works are ever exactly alike, the overall style, mood, and texture can be faithfully echoed&nbsp;across&nbsp;pieces.
                </p>
              </div>

              <div>
                <h3 className="text-2xl sm:text-3xl font-light text-sage-500 mb-3 sm:mb-4 tracking-tight">Lead Time</h3>
                <p className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light leading-relaxed text-justify hyphens-auto">
                  Because each piece is handcrafted, timing varies depending on its scale and complexity. Most bespoke pieces require 4 to 9 weeks, allowing for hand-building or wheel-throwing, drying, glazing, and&nbsp;multiple&nbsp;firings.
                </p>
              </div>

              <div>
                <h3 className="text-2xl sm:text-3xl font-light text-sage-500 mb-3 sm:mb-4 tracking-tight">Making & Firing</h3>
                <ul className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light leading-relaxed space-y-2">
                  <li className="text-justify hyphens-auto">- Pieces are shaped either on the wheel or through handbuilding techniques, depending on the&nbsp;desired&nbsp;form.</li>
                  <li className="text-justify hyphens-auto">- Pieces are glazed through a process of instinctive experimentation and&nbsp;material&nbsp;alchemy.</li>
                  <li className="text-justify hyphens-auto">- Surfaces are treated with a painterly touch, designed to resonate with the shape and spirit of&nbsp;each&nbsp;piece.</li>
                  <li className="text-justify hyphens-auto">- Every ceramic work undergoes a slow and careful process: bisque-fired, glazed, then high-fired, with patient drying between&nbsp;every&nbsp;stage.</li>
                </ul>
              </div>

              <div>
                <h3 className="text-2xl sm:text-3xl font-light text-sage-500 mb-3 sm:mb-4 tracking-tight">Final Steps</h3>
                <p className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light leading-relaxed mb-2 text-justify hyphens-auto">
                  Once your piece is complete, you'll receive detailed photographs for review and final approval&nbsp;before&nbsp;shipping.
                </p>
                <p className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light leading-relaxed text-justify hyphens-auto">
                  Worldwide delivery is available. Each work is carefully packaged using sustainable or custom materials, thoughtfully chosen to ensure protection and minimise&nbsp;environmental&nbsp;impact.
                </p>
              </div>
            </div>
          )}

          {bespokeExpanded && (
            <div className="text-center mt-8 sm:mt-12">
              <a 
                href="#contact" 
                onClick={handleNavClick}
                className="inline-flex items-center gap-2 px-8 py-3 border-2 border-sage-500 text-sage-500 hover:bg-sage-500 hover:text-white transition-colors text-sm tracking-widest uppercase whitespace-nowrap cursor-pointer rounded-full"
              >
                INQUIRE
              </a>
            </div>
          )}
        </div>
      </section>

      {/* About Section with existing animation */}
      <section id="about" className="py-16 sm:py-24 bg-logo-beige-50">
        <div className="max-w-5xl mx-auto px-6 lg:px-12">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-sage-500 mb-8 sm:mb-12 tracking-widest uppercase text-center">ABOUT</h2>
          
          <div className={`relative flex flex-col sm:flex-row sm:items-start gap-6 md:gap-10 ${aboutTextVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
            {/* Left side - Images */}
            <div className="w-full sm:w-80 md:w-96 flex-shrink-0 space-y-6">
              {/* Mobile: Show rotating image when expanded, first image when collapsed */}
              <div className="md:hidden">
                <img 
                  src={aboutExpanded ? aboutImages[currentAboutImageIndex] : aboutImages[0]}
                  alt={aboutExpanded ? `Nicole Abou Farhat - Image ${currentAboutImageIndex + 1}` : "Nicole Abou Farhat"}
                  className="w-full h-auto object-cover transition-opacity duration-500"
                  key={currentAboutImageIndex}
                />
              </div>

              {/* Desktop: Show all images when expanded, first image when collapsed */}
              <div className="hidden md:block space-y-6">
                <img 
                  src={aboutImages[0]}
                  alt="Nicole Abou Farhat"
                  className="w-full h-auto object-cover"
                />
                
                {aboutExpanded && (
                  <>
                    <img 
                      src={aboutImages[1]}
                      alt="Pottery craftsmanship"
                      className="w-full h-auto object-cover"
                    />
                    <img 
                      src={aboutImages[2]}
                      alt="Studio workspace"
                      className="w-full h-auto object-cover"
                    />
                    <img 
                      src={aboutImages[3]}
                      alt="Artist examining finished work"
                      className="w-full h-auto object-cover"
                    />
                  </>
                )}
              </div>
            </div>
            
            {/* Right side - Text with increased top padding for better alignment */}
            <div className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light leading-relaxed space-y-4 sm:space-y-6 flex-1 md:pt-20">
              <p className="text-justify hyphens-auto">
                Nicole Abou Farhat is a multidisciplinary designer whose creative journey flows between architecture, craft, and the poetry of everyday life. Trained as an interior architect at the Académie Libanaise des Beaux Arts <span className="italic">("ALBA")</span>, where she earned both her Bachelor's and Master's degrees, Nicole spent a decade designing thoughtful, elegant residential spaces across Lebanon. She later completed a Master's in Lighting Design & Technology at the Politecnico di Milano, an experience that sharpened her sensitivity to light and atmosphere and broadened her design identity within&nbsp;Milan's vibrant creative&nbsp;scene.
              </p>
              
              {aboutExpanded && (
                <>
                  <p className="text-justify hyphens-auto">
                    Her world shifted in 2020, in the wake of the Beirut port explosion and the surrounding crisis that engulfed her country. Seeking calm and creative renewal, she moved to Paris with the intention of continuing her architectural path, but a chance encounter with a ceramics class quietly redirected&nbsp;her&nbsp;course.
                  </p>
                  <p className="text-justify hyphens-auto">
                    What began as a form of therapy soon revealed itself to be a new and deeply&nbsp;personal&nbsp;language.
                  </p>
                  <p className="text-justify hyphens-auto">
                    Clay, with its rawness and rhythm, awakened something instinctive. She immersed herself in the craft, studying at Atelier Chemins de la Céramique, earning a Certificat d'Aptitude Professionnelle in wheel-throwing, and refining her skills through workshops with celebrated ceramicists across Paris, Beirut, Doha, and Dubai. In 2022, she founded Nicole Abou Farhat, a creative home where architecture meets the organic, and functionality meets&nbsp;the&nbsp;emotional.
                  </p>
                  <p className="text-justify hyphens-auto">
                    Nicole's pieces draw inspiration from nature and everyday beauty: the texture of stones, the palette of dried leaves and driftwood, the imperfect geometry of trees, sand, and sea, and more recently, the intimate presence of her newborn child. Her forms echo structure, yet feel soft to the eye and hand; her deep love for colour is central to her process, bold, joyful, and rooted in emotion. She celebrates its vibrancy, its moods, and the emotional resonance it brings&nbsp;to&nbsp;form.
                  </p>
                  <p className="text-justify hyphens-auto">
                    Each object she creates is a celebration of life, form, function, and feeling, made to bring warmth, character, and quiet sophistication into the spaces&nbsp;we&nbsp;live&nbsp;in.
                  </p>
                  <p className="text-justify hyphens-auto">
                    Nicole also offers private and group ceramic classes, inviting others to experience the quiet therapy of working with clay. Her sessions offer a space where people can slow down, reconnect, and discover the grounding rhythm of working with their hands, a simple and effective way to disconnect from daily stress. For her, clay is more than a material; it is a way to step away from the noise and return to the&nbsp;present&nbsp;moment.
                  </p>
                </>
              )}
              
              {/* Quote - Always visible with shiny hover effect */}
              <p className="text-lg sm:text-xl md:text-2xl text-sage-700 hover:text-sage-600 transition-colors font-light italic leading-relaxed text-justify hyphens-auto">
                "Clay teaches us patience, humility, and the beauty of imperfection. Every piece carries within it the story of earth, fire, water, and the human hand that&nbsp;shaped&nbsp;it."
              </p>
              
              {!aboutExpanded && (
                <div className="text-center pt-4">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setAboutExpanded(true);
                    }}
                    className="inline-flex items-center gap-2 px-8 py-3 border-2 border-sage-500 text-sage-500 hover:bg-sage-500 hover:text-white transition-colors text-sm tracking-widest uppercase whitespace-nowrap cursor-pointer rounded-full"
                  >
                    READ MORE
                    <i className="ri-arrow-down-s-line text-xl"></i>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section with animations */}
      <section id="contact" className={`py-16 sm:py-24 bg-logo-beige-50 transition-all duration-800 ${contactVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
        <div className="max-w-6xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-12 sm:mb-16 animate-fadeIn">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-sage-500 mb-4 sm:mb-6 tracking-widest uppercase text-center">CONTACT</h2>
            <p className="text-lg sm:text-xl md:text-2xl text-sage-700 font-light max-w-none mx-auto text-left hyphens-auto" style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
              Let's bring your vision to life, feel free to get in touch or visit the studio to explore&nbsp;it&nbsp;together.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 items-start">
            <div className="space-y-6 sm:space-y-8 order-1 md:order-1 relative z-10 animate-fadeIn-delay-1">
              <a 
                href="mailto:contact@nicoleaboufarhat.com" 
                onClick={(e) => {
                  // Allow default mailto behavior
                }}
                className="flex items-start space-x-4 cursor-pointer hover:opacity-80 transition-opacity relative z-10"
              >
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-base sm:text-lg text-sage-500"></i>
                </div>
                <div>
                  <h3 className="text-xl sm:text-2xl font-bold text-sage-500 mb-1">Email</h3>
                  <span className="text-lg sm:text-xl text-sage-500 break-all">
                    contact@nicoleaboufarhat.com
                  </span>
                </div>
              </a>

              <a 
                href="https://www.instagram.com/nicoleaboufarhat_studio/" 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={(e) => {
                  // Allow default link behavior
                }}
                className="flex items-start space-x-4 cursor-pointer hover:opacity-80 transition-opacity relative z-10"
              >
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-instagram-line text-base sm:text-lg text-sage-500"></i>
                </div>
                <div>
                  <h3 className="text-xl sm:text-2xl font-bold text-sage-500 mb-1">Instagram</h3>
                  <span className="text-lg sm:text-xl text-sage-500 break-all">
                    @nicoleaboufarhat_studio
                  </span>
                </div>
              </a>

              {/* Logo - Same size as 4-picture square from gallery (2x2 grid) */}
              <div className="mt-8 hidden md:block order-3 relative z-0" style={{ maxWidth: '100%', width: '100%' }}>
                <img 
                  src="https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/041835f6e796981a63c99e9a57b338db.png"
                  alt="Nicole Abou Farhat Studio Logo"
                  className="w-full h-auto object-contain cursor-pointer"
                  style={{ transform: 'scale(1.665) translate(-6%, -6%)' }}
                  onClick={handleLogoClick}
                />
              </div>
            </div>

            <div className="space-y-4 sm:space-y-6 order-2 md:order-2 relative z-20 animate-fadeIn-delay-2">
              <div className="bg-sage-500 p-6 sm:p-8 rounded-3xl">
                <h3 className="text-lg sm:text-xl font-bold text-white mb-4 sm:mb-6 text-center">SEND A MESSAGE</h3>
                <form className="space-y-3 sm:space-y-4" onSubmit={handleContactSubmit} data-readdy-form id="contact-form">
                  <div>
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name"
                      required
                      className="w-full px-4 sm:px-5 py-3 sm:py-4 border border-sage-600 bg-logo-beige-50 rounded-full focus:outline-none focus:ring-2 focus:ring-white/30 text-base sm:text-lg text-gray-800 placeholder-gray-600"
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      name="email"
                      placeholder="Your Email"
                      required
                      className="w-full px-4 sm:px-5 py-3 sm:py-4 border border-sage-600 bg-logo-beige-50 rounded-full focus:outline-none focus:ring-2 focus:ring-white/30 text-base sm:text-lg text-gray-800 placeholder-gray-600"
                    />
                  </div>
                  <div className="relative">
                    <textarea
                      name="message"
                      placeholder="Your Message"
                      rows={4}
                      maxLength={500}
                      required
                      onChange={(e) => setContactMessageLength(e.target.value.length)}
                      className="w-full px-4 sm:px-5 py-3 sm:py-4 border border-sage-600 bg-logo-beige-50 rounded-3xl focus:outline-none focus:ring-2 focus:ring-white/30 text-base sm:text-lg resize-none text-gray-800 placeholder-gray-600"
                    ></textarea>
                    <div className="absolute bottom-2 right-4 text-xs text-gray-600 bg-logo-beige-50/80 px-2 py-1 rounded">
                      {contactMessageLength}/500
                    </div>
                  </div>
                  <button
                    type="submit"
                    disabled={contactFormStatus === 'submitting'}
                    className="w-full bg-sage-500 text-white py-3 sm:py-4 rounded-full hover:bg-sage-600 transition-colors text-lg sm:text-xl tracking-wide uppercase whitespace-nowrap cursor-pointer font-bold border border-sage-600 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {contactFormStatus === 'submitting' ? 'SENDING...' : contactFormStatus === 'success' ? 'MESSAGE SENT!' : contactFormStatus === 'error' ? 'ERROR - TRY AGAIN' : 'SEND MESSAGE'}
                  </button>
                </form>
              </div>

              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowOrderModal(true);
                }}
                className="w-full px-6 sm:px-8 py-3 sm:py-4 bg-[#C09080] text-white hover:bg-[#B08070] transition-colors text-lg sm:text-xl tracking-wide uppercase whitespace-nowrap cursor-pointer rounded-full font-bold relative z-30"
              >
                PLACE YOUR ORDER
              </button>
            </div>

            {/* Logo for mobile - shown at the end on mobile only */}
            <div className="mt-8 md:hidden order-3 relative z-0" style={{ maxWidth: '100%', width: '100%' }}>
              <img 
                src="https://static.readdy.ai/image/7a8509b0cd0414d3d34c86a6a590e9aa/041835f6e796981a63c99e9a57b338db.png"
                alt="Nicole Abou Farhat Studio Logo"
                className="w-full h-auto object-contain cursor-pointer"
                style={{ transform: 'scale(1.665) translate(-6%, -6%)' }}
                onClick={handleLogoClick}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Footer with fade-in */}
      <footer className="bg-logo-beige-50 border-t border-gray-100 py-8 sm:py-12 animate-fadeIn">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4">
            <p className="text-sm sm:text-base text-sage-700 font-light tracking-wide text-center">
              © 2025 Nicole Abou Farhat Studio. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* Order Modal with smooth entrance */}
      {showOrderModal && (
        <div 
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100] p-4 overflow-y-auto animate-fadeIn"
          onClick={(e) => {
            e.stopPropagation();
            setShowOrderModal(false);
          }}
        >
          <div 
            className="bg-[#C09080] rounded-3xl max-w-md w-full p-6 sm:p-8 relative my-8 animate-fadeIn-delay-1"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowOrderModal(false);
              }}
              className="absolute top-4 right-4 text-white hover:text-logo-beige-100 transition-colors z-10"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            
            <h3 className="text-lg sm:text-xl font-bold text-white mb-4 sm:mb-6 text-center pr-8">PLACE YOUR ORDER</h3>
            
            <form onSubmit={handleOrderSubmit} className="space-y-3 sm:space-y-4" data-readdy-form id="custom-order-form">
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  className="w-full px-4 sm:px-5 py-3 sm:py-4 border border-[#B08070] bg-logo-beige-50 rounded-full focus:outline-none focus:ring-2 focus:ring-white/30 text-base sm:text-lg text-gray-800 placeholder-gray-600"
                />
              </div>
              
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  required
                  className="w-full px-4 sm:px-5 py-3 sm:py-4 border border-[#B08070] bg-logo-beige-50 rounded-full focus:outline-none focus:ring-2 focus:ring-white/30 text-base sm:text-lg text-gray-800 placeholder-gray-600"
                />
              </div>
              
              <div>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Your Phone"
                  className="w-full px-4 sm:px-5 py-3 sm:py-4 border border-[#B08070] bg-logo-beige-50 rounded-full focus:outline-none focus:ring-2 focus:ring-white/30 text-base sm:text-lg text-gray-800 placeholder-gray-600"
                />
              </div>
              
              {/* Modern Collection Dropdown */}
              <div className="collection-dropdown-container relative">
                <input type="hidden" name="collection" value={selectedCollection} required />
                <button
                  type="button"
                  onClick={() => setIsCollectionDropdownOpen(!isCollectionDropdownOpen)}
                  className="w-full px-4 sm:px-5 py-3 sm:py-4 rounded-full text-left transition-all duration-300 flex items-center justify-between border border-[#B08070] bg-logo-beige-50 text-base sm:text-lg"
                  style={{
                    color: selectedCollection ? '#374151' : '#6B7280'
                  }}
                >
                  <span>{selectedCollection || 'Select Collection'}</span>
                  <i className={`ri-arrow-${isCollectionDropdownOpen ? 'up' : 'down'}-s-line text-xl transition-transform duration-300`}></i>
                </button>

                {isCollectionDropdownOpen && (
                  <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-3xl shadow-2xl border-2 border-[#B08070] overflow-hidden z-50 max-h-80 overflow-y-auto animate-slideDown">
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedCollection('');
                        setIsCollectionDropdownOpen(false);
                      }}
                      className="w-full px-4 sm:px-5 py-3 text-left transition-all duration-200 hover:bg-logo-beige-100 flex items-center justify-between group"
                    >
                      <span className="text-base sm:text-lg font-medium text-gray-800">Select Collection</span>
                      {selectedCollection === '' && (
                        <i className="ri-check-line text-xl text-sage-500"></i>
                      )}
                    </button>
                    {collectionOptions.map((option, index) => (
                      <button
                        key={option}
                        type="button"
                        onClick={() => {
                          setSelectedCollection(option);
                          setIsCollectionDropdownOpen(false);
                        }}
                        className="w-full px-4 sm:px-5 py-3 text-left transition-all duration-200 hover:bg-logo-beige-100 flex items-center justify-between group"
                        style={{
                          animationDelay: `${(index + 1) * 30}ms`,
                        }}
                      >
                        <span className="text-base sm:text-lg font-medium text-gray-800">{option}</span>
                        {selectedCollection === option && (
                          <i className="ri-check-line text-xl text-sage-500"></i>
                        )}
                      </button>
                    ))}
                  </div>
                )}
              </div>
              
              {/* Modern Size Dropdown */}
              <div className="size-dropdown-container relative">
                <input type="hidden" name="size" value={selectedSize} required />
                <button
                  type="button"
                  onClick={() => setIsSizeDropdownOpen(!isSizeDropdownOpen)}
                  className="w-full px-4 sm:px-5 py-3 sm:py-4 rounded-full text-left transition-all duration-300 flex items-center justify-between border border-[#B08070] bg-logo-beige-50 text-base sm:text-lg"
                  style={{
                    color: selectedSize ? '#374151' : '#6B7280'
                  }}
                >
                  <span>{selectedSize || 'Select Size'}</span>
                  <i className={`ri-arrow-${isSizeDropdownOpen ? 'up' : 'down'}-s-line text-xl transition-transform duration-300`}></i>
                </button>

                {isSizeDropdownOpen && (
                  <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-3xl shadow-2xl border-2 border-[#B08070] overflow-hidden z-50 animate-slideDown">
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedSize('');
                        setIsSizeDropdownOpen(false);
                      }}
                      className="w-full px-4 sm:px-5 py-3 text-left transition-all duration-200 hover:bg-logo-beige-100 flex items-center justify-between group"
                    >
                      <span className="text-base sm:text-lg font-medium text-gray-800">Select Size</span>
                      {selectedSize === '' && (
                        <i className="ri-check-line text-xl text-sage-500"></i>
                      )}
                    </button>
                    {sizeOptions.map((option, index) => (
                      <button
                        key={option}
                        type="button"
                        onClick={() => {
                          setSelectedSize(option);
                          setIsSizeDropdownOpen(false);
                        }}
                        className="w-full px-4 sm:px-5 py-3 text-left transition-all duration-200 hover:bg-logo-beige-100 flex items-center justify-between group"
                        style={{
                          animationDelay: `${(index + 1) * 30}ms`,
                        }}
                      >
                        <span className="text-base sm:text-lg font-medium text-gray-800">{option}</span>
                        {selectedSize === option && (
                          <i className="ri-check-line text-xl text-sage-500"></i>
                        )}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Modern Custom Color Dropdown */}
              <div className="color-dropdown-container relative">
                <input type="hidden" name="color" value={selectedColor} required />
                <button
                  type="button"
                  onClick={() => setIsColorDropdownOpen(!isColorDropdownOpen)}
                  className="w-full px-4 sm:px-5 py-3 sm:py-4 rounded-full text-left transition-all duration-300 flex items-center justify-between border border-[#B08070] bg-logo-beige-50 text-base sm:text-lg"
                  style={{
                    backgroundColor: selectedColor && selectedColor !== '' && selectedColor !== 'Custom Color (Specify in Details)' ? colorMap[selectedColor] || '#F5F1E8' : undefined,
                    color: selectedColor && selectedColor !== 'Custom Color (Specify in Details)' && ['Charcoal', 'Olive Green', 'Burnt Sienna', 'Rust Orange', 'Ocean Blue', 'Lavender', 'Sage Green'].includes(selectedColor) ? '#FFFFFF' : '#4B5563',
                    opacity: selectedColor && selectedColor !== '' && selectedColor !== 'Custom Color (Specify in Details)' ? 0.85 : undefined,
                    filter: selectedColor && selectedColor !== '' && selectedColor !== 'Custom Color (Specify in Details)' ? 'saturate(0.8)' : undefined,
                  }}
                >
                  <span>{selectedColor || 'Select Color Preference'}</span>
                  <i className={`ri-arrow-${isColorDropdownOpen ? 'up' : 'down'}-s-line text-xl transition-transform duration-300`} style={{ color: '#4B5563' }}></i>
                </button>

                {isColorDropdownOpen && (
                  <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-3xl shadow-2xl border-2 border-[#B08070] overflow-hidden z-50 max-h-80 overflow-y-auto animate-slideDown">
                    {colorOptions.map((option, index) => (
                      <button
                        key={option.value}
                        type="button"
                        onClick={() => {
                          setSelectedColor(option.value);
                          setIsColorDropdownOpen(false);
                        }}
                        className="w-full px-4 sm:px-5 py-3 text-left transition-all duration-200 hover:scale-[1.02] flex items-center gap-3 group"
                        style={{
                          backgroundColor: option.color,
                          color: '#4B5563',
                          animationDelay: `${index * 30}ms`,
                          opacity: 0.85,
                          filter: 'saturate(0.8)',
                        }}
                      >
                        <div 
                          className="w-6 h-6 rounded-full border-2 flex-shrink-0 transition-transform duration-200 group-hover:scale-110"
                          style={{
                            backgroundColor: option.color,
                            borderColor: '#4B5563',
                            opacity: 0.9,
                            filter: 'saturate(0.75)',
                          }}
                        ></div>
                        <span className="text-base sm:text-lg font-medium" style={{ color: '#4B5563' }}>{option.name}</span>
                        {selectedColor === option.value && (
                          <i className="ri-check-line text-xl" style={{ color: '#4B5563' }}></i>
                        )}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Modern Glaze Finish Dropdown */}
              <div className="glaze-dropdown-container relative">
                <input type="hidden" name="glaze" value={selectedGlaze} required />
                <button
                  type="button"
                  onClick={() => setIsGlazeDropdownOpen(!isGlazeDropdownOpen)}
                  className="w-full px-4 sm:px-5 py-3 sm:py-4 rounded-full text-left transition-all duration-300 flex items-center justify-between border border-[#B08070] bg-logo-beige-50 text-base sm:text-lg"
                  style={{
                    color: selectedGlaze ? '#374151' : '#6B7280'
                  }}
                >
                  <span>{selectedGlaze || 'Select Glaze'}</span>
                  <i className={`ri-arrow-${isGlazeDropdownOpen ? 'up' : 'down'}-s-line text-xl transition-transform duration-300`}></i>
                </button>

                {isGlazeDropdownOpen && (
                  <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-3xl shadow-2xl border-2 border-[#B08070] overflow-hidden z-50 animate-slideDown">
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedGlaze('');
                        setIsGlazeDropdownOpen(false);
                      }}
                      className="w-full px-4 sm:px-5 py-3 text-left transition-all duration-200 hover:bg-logo-beige-100 flex items-center justify-between group"
                    >
                      <span className="text-base sm:text-lg font-medium text-gray-800">Select Glaze</span>
                      {selectedGlaze === '' && (
                        <i className="ri-check-line text-xl text-sage-500"></i>
                      )}
                    </button>
                    {glazeOptions.map((option, index) => (
                      <button
                        key={option}
                        type="button"
                        onClick={() => {
                          setSelectedGlaze(option);
                          setIsGlazeDropdownOpen(false);
                        }}
                        className="w-full px-4 sm:px-5 py-3 text-left transition-all duration-200 hover:bg-logo-beige-100 flex items-center justify-between group"
                        style={{
                          animationDelay: `${(index + 1) * 30}ms`,
                        }}
                      >
                        <span className="text-base sm:text-lg font-medium text-gray-800">{option}</span>
                        {selectedGlaze === option && (
                          <i className="ri-check-line text-xl text-sage-500"></i>
                        )}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <div className="relative">
                <textarea
                  name="details"
                  placeholder="Order Details & Special Requests"
                  rows={4}
                  maxLength={500}
                  required
                  value={undefined}
                  onChange={(e) => setOrderDetailsLength(e.target.value.length)}
                  className="w-full px-4 sm:px-5 py-3 sm:py-4 border border-[#B08070] bg-logo-beige-50 rounded-3xl focus:outline-none focus:ring-2 focus:ring-white/30 text-base sm:text-lg resize-none text-gray-800 placeholder-gray-600"
                ></textarea>
                <div className="absolute bottom-2 right-4 text-xs text-gray-600 bg-logo-beige-50/80 px-2 py-1 rounded">
                  {orderDetailsLength}/500
                </div>
              </div>

              <button
                type="submit"
                disabled={orderFormStatus === 'submitting'}
                className="w-full bg-[#C09080] text-white py-3 sm:py-4 rounded-full hover:bg-[#B08070] transition-colors text-lg sm:text-xl tracking-wide uppercase whitespace-nowrap cursor-pointer font-bold border border-[#B08070]"
              >
                {orderFormStatus === 'submitting' ? 'SUBMITTING...' : orderFormStatus === 'success' ? 'ORDER SUBMITTED!' : orderFormStatus === 'error' ? 'ERROR - TRY AGAIN' : 'SUBMIT ORDER'}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
